import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';

import { CampaignService } from 'app/layout/campaign.service';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import ClearcalsIcons from 'app/icons/icons.data';

@Component({
	selector: 'clearcals-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	isCampaignActive: boolean;
	private unsubscribeAll: Subject<any>;

	// icons
	facebookIcon = ClearcalsIcons.getIcon('facebook');
	twitterIcon = ClearcalsIcons.getIcon('twitter');
	linkedinIcon = ClearcalsIcons.getIcon('linkedin');
	instagramIcon = ClearcalsIcons.getIcon('instagram');
	youtubeIcon = ClearcalsIcons.getIcon('youtube');

	constructor(
		private campaignService: CampaignService,
		private router: Router,
		private viewportScroller: ViewportScroller,
	) {
		this.unsubscribeAll = new Subject();
	}

	goToTop() {
		this.router.navigate(['/']).then(() => {
			this.viewportScroller.scrollToPosition([0, 0]);
		});
	}

	ngOnInit(): void {
		this.campaignService.isCampaignActive$
			.pipe(takeUntil(this.unsubscribeAll))
			.subscribe((status) => {
				this.isCampaignActive = status;
			});
	}
}
